<div *ngIf="data$ | async as data" class="w-full md:max-w-screen-md lg:max-w-screen-lg mx-auto px-4">
    <organ-rd-author-main-mb [data]="data" [ui]="ui" class="border-b mb-3 pb-4"></organ-rd-author-main-mb>
    <organ-rd-author-tab-page-mb [data]="data" [ui]="ui" (action)="action($event)"></organ-rd-author-tab-page-mb>
</div>